import React, { useEffect, useRef, useState } from "react";
import ResturantNameInput from "../../components/GeneralSettingsInputs/ResturantNameInput";
import ResturantDescription from "../../components/GeneralSettingsInputs/ResturantDescription";
import { useSelector } from "react-redux";
import axios from "axios";
import { object, string } from "yup";
import { toast } from "react-hot-toast";
import * as Yup from "yup";
import { Skeleton } from "@/components/ui/skeleton";
import { Cropper, ReactCropperElement } from "react-cropper";
import { useTranslation } from "react-i18next";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";

function GeneralSettings() {
  const { t, i18n } = useTranslation();
  const locale = i18n.language

  const [formData, setFormData] = useState({
    nameAR: "",
    nameEn: "",
    descriptionAr: "",
    descriptionEn: "",
    restaurantPhone: "",
    whatsapp: "",
    facebook: "",
    x: "",
    linkedin: "",
    instagram: "",
    snapchat: "",
    tiktok: "",
  });
  const tiktokRegex =
    /^(https?:\/\/)?(www\.)?tiktok\.com(\/(@[a-zA-Z0-9._-]+))?\/?$/;
  const snapchatRegex =
    /^(https?:\/\/)?(web\.)?(www\.)?snapchat\.com(\/(add|story)\/[a-zA-Z0-9._-]+)?\/?$/;
  const facebookRegex =
    /^(https?:\/\/)?(www\.)?facebook\.com(\/[A-Za-z0-9._-]+)?\/?$/;
  const instgramRegex =
    /^(https?:\/\/)?(www\.)?instagram\.com(\/[A-Za-z0-9._-]+)?\/?$/;
  const linkedinRegex =
    /^(https?:\/\/)?(www\.)?linkedin\.com\/?(in\/[A-Za-z0-9_-]+)?\/?$/;
  const xRegex = /^(https?:\/\/)?(www\.)?x\.com(\/[A-Za-z0-9._-]+)?\/?$/;
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );
  const [fileURLs, setFileURLs] = useState<{ [key: string]: string | null }>({
    logo: null,
    favicon: null,
  });
  const [files, setFiles] = useState<{ [key: string]: File | null }>({
    logo: null,
    favicon: null,
  });
  const MAX_IMAGE_SIZE = 10 * 1024 * 1024; // 10MB
  const MAX_IMAGE_SIZE_MB_String = {
    en: `${MAX_IMAGE_SIZE / 1024 / 1024}MB`,
    ar: `${MAX_IMAGE_SIZE / 1024 / 1024} ميجابايت`,
  }; // STRING
  const [croppedLogoFile, setCroppedLogoFile] = useState<File | null>(null);
  const [logoError, setLogoError] = useState(false);
  const phoneRegex = /^5\d{8}$/;
  const [cropedOpen, setCropedOpen] = useState(false);
  const cropperRef = useRef<ReactCropperElement>(null);
  const [croppedUrl, setCroppedUrl] = useState<string | null>(null);
  const [buttonView, setButtonView] = useState(false);
  const [nameError, setNameError] = useState(false);
  const [discriptionError, setDescriptionError] = useState(false);
  const [beforeCrop, setBeforeCrop] = useState("")
  useLockBodyScroll(cropedOpen);
  const inputRef = useRef<HTMLInputElement>(null);
  function toggleCropedOpen() {
    setCropedOpen(!cropedOpen);
  }
  const validation = object({


    restaurantPhone: string()
      .required(t("phoneRequired") as string)
      .matches(
        phoneRegex,
        t("settingsValid.phoneInvalid") as string,
      ),

    whatsapp: string()
      .nullable()
      .notRequired()
      .matches(
        phoneRegex,
        t("settingsValid.phoneInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    facebook: string()
      .nullable()
      .notRequired()
      .matches(
        facebookRegex,
        t("settingsValid.facebookInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    x: string()
      .nullable()
      .notRequired()
      .matches(
        xRegex,
        t("settingsValid.xInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    linkedin: string()
      .nullable()
      .notRequired()
      .matches(
        linkedinRegex,
        t("settingsValid.linkedinInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    instagram: string()
      .nullable()
      .notRequired()
      .matches(
        instgramRegex,
        t("settingsValid.instagramInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    tiktok: string()
      .nullable()
      .notRequired()
      .matches(
        tiktokRegex,
        t("settingsValid.tiktokInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),

    snapchat: string()
      .nullable()
      .notRequired()
      .matches(
        snapchatRegex,
        t("settingsValid.snapchatInvalid") as string,
      )
      .transform((value) => (value === "" ? null : value)),
  });


  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  async function getUserSettings() {
    setLoading(true);
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/settings/restaurant`,
        method: "GET",
        headers: {
          Authorization: token,
        },
      };
      const response = await axios.request(options);

      setFileURLs({

        favicon: response.data.favicon || null,
      });
      setBeforeCrop(response.data.logo || null)
      setFormData({
        nameAR: response.data.nameAR || "",
        nameEn: response.data.nameEN || "",
        descriptionAr: response.data.descriptionAR || "",
        descriptionEn: response.data.descriptionEN || "",
        restaurantPhone: response.data.restaurantPhone || "",
        whatsapp: response.data.whatsapp || "",
        facebook: response.data.facebook || "",
        x: response.data.x || "",
        linkedin: response.data.linkedin || "",
        instagram: response.data.instagram || "",
        snapchat: response.data.snapchat || "",
        tiktok: response.data.tiktok || "",
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getUserSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    inputName: string,
  ) => {
    const file = e.target.files?.[0];
    if (file && file?.size > MAX_IMAGE_SIZE) {
      toast.error(
        t("fileSizeExceeded", { size: MAX_IMAGE_SIZE_MB_String[i18n.language as "en" | "ar"] }) as string,
      );
      e.target.value = "";
      return;
    }
    if (file) {
      const newFileURL = URL.createObjectURL(file);
      setFileURLs((prev) => ({
        ...prev,
        [inputName]: newFileURL,
      }));
      setFiles((prev) => ({
        ...prev,
        [inputName]: file,
      }));
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.nameAR === "" && formData.nameEn === "") {
      setNameError(true);
    }
    if (formData.descriptionAr === "" && formData.descriptionEn === "") {
      setDescriptionError(true);
    }
    if (discriptionError) return
    if (nameError) return
    setButtonView(false);
    const toastId = toast.loading(
      t("updatingSettings") as string,
    );

    try {
      await validation.validate(formData, { abortEarly: false });
      setErrors({});

      const newData = new FormData();
      if (fileURLs.logo === null) {
        setLogoError(true);
        return;
      }


      if (croppedLogoFile) newData.append("logo", croppedLogoFile);
      if (files.favicon === null) {
        newData.append("favicon", "");
      } else if (files.favicon) {
        newData.append("favicon", files.favicon);

      }

      newData.append("nameAR", formData.nameAR);
      newData.append("nameEN", formData.nameEn);
      newData.append("descriptionAR", formData.descriptionAr);
      newData.append("descriptionEN", formData.descriptionEn);
      newData.append("whatsapp", formData.whatsapp);
      newData.append("facebook", formData.facebook);
      newData.append("x", formData.x);
      newData.append("linkedin", formData.linkedin);
      newData.append("instagram", formData.instagram);
      newData.append("restaurantPhone", formData.restaurantPhone);
      newData.append("snapchat", formData.snapchat);
      newData.append("tiktok", formData.tiktok);

      const options = {
        url: `${baseUrl}/api/dashboard/settings/restaurant`,
        method: "PUT",
        headers: {
          Authorization: token,
          "Content-Type": "multipart/form-data",
        },
        data: newData,
      };

      const response = await axios.request(options);
      if (response.data.success) {
        toast.success(
          t("settingsUpdated") as string,
        );
      }
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const validationErrors: { [key: string]: string } = {};
        error.inner.forEach((err) => {
          if (err.path) validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      }
    } finally {
      toast.dismiss(toastId);
    }
  };

  const updateRestaurantName = async (newValues: {
    ar: string;
    en: string;
  }) => {
    // Update form data
    setFormData((prev) => ({
      ...prev,
      nameAR: newValues.ar, // Match the case style of descriptionAr
      nameEn: newValues.en,
    }));

    if (newValues.ar === "" && newValues.en === "") {
      setNameError(true);
    } else {
      setNameError(false);
    }
  };

  const updateRestaurantDescription = async (newValues: {
    ar: string;
    en: string;
  }) => {
    // Update form data
    setFormData((prev) => ({
      ...prev,
      descriptionAr: newValues.ar,
      descriptionEn: newValues.en,
    }));

    if (newValues.ar === "" && newValues.en === "") {
      setDescriptionError(true);
    } else {
      setDescriptionError(false);
    }
  };

  const updateContactInput = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Clean the input: remove spaces and leading zeros
    const cleanedValue = value.replace(/\s+/g, '').replace(/^0+/, '');

    // Update form data with cleaned value
    setFormData((prev) => ({
      ...prev,
      [name]: cleanedValue,
    }));

    // Validate the cleaned value
    try {
      await validation.validateAt(name, { [name]: cleanedValue });

      // Clear any existing error for this field
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    } catch (err) {
      if (err instanceof Error && "path" in err && "message" in err) {
        setErrors((prev) => ({
          ...prev,
          [name]: err.message, // Add the specific error message
        }));
      }
    }
  };


  const onCrop = () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;

    // Get the cropped canvas with the current crop box size
    const croppedCanvas = cropper.getCroppedCanvas({
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high", // High quality smoothing
    });

    if (!croppedCanvas) return;

    // Convert to Blob (asynchronous) for file saving
    croppedCanvas.toBlob(
      (blob) => {
        if (blob) {
          const file = new File([blob], "cropped-image.webp", { type: "image/webp" });
          setCroppedLogoFile(file); // Save the file
        }
      },
      "image/webp",
      1.0 // Maximum quality
    );

    // Convert to Base64 (synchronous)
    const base64Url = croppedCanvas.toDataURL("image/png", 1.0);
    setCroppedUrl(base64Url);
  };




  return (
    <>
      {cropedOpen && (
        <div
          onClick={toggleCropedOpen}
          className="fixed left-0 top-0 z-[99999] flex h-full w-full flex-col items-center justify-center bg-black bg-opacity-50 px-5"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="relative flex w-full flex-col items-center gap-5 rounded-md bg-white px-4 py-8 md:w-[60%]"
          >
            {fileURLs.logo && (
              <Cropper
                src={fileURLs.logo || ""}
                style={{ height: 500, width: "100%" }}
                aspectRatio={NaN}            // 🔓 Allow free aspect ratio
                viewMode={1}                 // Restricts cropping to image bounds
                zoomable={true}              // 🔍 Allow zooming
                scalable={true}              // 🔄 Optional: allow image scaling
                cropBoxResizable={true}      // ✅ Let user resize the crop box
                cropBoxMovable={true}        // ✋ Drag crop box freely
                autoCropArea={1}             // Show full image initially
                ref={cropperRef}
              />

            )}
            <div className="text-center">
              {t("bestResolution")}
            </div>
            <div className="flex items-center justify-center gap-5">
              <button
                onClick={() => {
                  onCrop();
                  toggleCropedOpen();
                }}
                className="mt-2 rounded-md bg-sidebar px-5 py-2 text-base font-medium text-skyblue"
              >
                {t("save")}
              </button>
              <button
                type="button"
                className="mt-2 rounded-md bg-error px-5 py-2 text-base font-medium text-white"
                onClick={() => {
                  setButtonView(false)
                  setFileURLs({ ...fileURLs, logo: null })
                  if (inputRef.current) inputRef.current.value = ""
                  toggleCropedOpen()
                }}
              >
                {t("close")}
              </button>
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <>
          <div className="felx w-full flex-col items-center justify-center gap-5">
            <Skeleton className="mx-auto my-8 h-[200px] w-1/2 rounded-lg md:w-[200px] dark:bg-gray-500 dark:bg-opacity-40" />
            <Skeleton className="mx-auto my-8 h-[50px] w-full rounded-lg md:w-[800px] dark:bg-gray-500 dark:bg-opacity-40" />
            <Skeleton className="mx-auto my-8 h-[50px] w-full rounded-lg md:w-[800px] dark:bg-gray-500 dark:bg-opacity-40" />
            <Skeleton className="mx-auto my-8 h-[50px] w-full rounded-lg md:w-[800px] dark:bg-gray-500 dark:bg-opacity-40" />
            <Skeleton className="mx-auto my-8 h-[50px] w-full rounded-lg md:w-[800px] dark:bg-gray-500 dark:bg-opacity-40" />
          </div>
        </>
      ) : (
        <>
          <h1 className="mb-5 self-start text-2xl font-semibold">
            {t("general")}
          </h1>
          <div className="flex flex-col items-center justify-center gap-6 rounded-md border border-gray-300 bg-white px-4 py-8">
            {/* Logo Preview */}
            <div className="text-center">
              <div className="mx-auto flex h-44 w-44 items-center justify-center overflow-hidden rounded-sm bg-gray-200">
                {beforeCrop || croppedUrl ? (
                  <img
                    src={croppedUrl || beforeCrop}
                    alt="Logo Preview"
                    className="h-full w-full object-contain"
                  />
                ) : (
                  <span className="text-lg font-bold text-gray-500">
                    {t("logo.noLogo")}
                  </span>
                )}
              </div>

              <p className="pt-1 text-sm text-slate-400">
                {t("logo.supportedFormats")}{" "}
                <span>.jpg, .jpeg, .png</span>
              </p>
              <p className="pb-1 text-sm text-slate-400">
                {t("logo.recommendedSize")}
              </p>
              <p className="pb-1 text-sm text-slate-400">{t("maxSize")}</p>
              {logoError && (
                <p className="pb-1 text-sm text-red-500">
                  {t("logo.uploadRequired")}
                </p>
              )}
              <label
                htmlFor="logo"
                className="mt-2 block cursor-pointer text-lg font-semibold text-gray-500 hover:text-sidebar"
              >
                {t("logo.upload")}
              </label>
              {buttonView && (
                <button
                  onClick={toggleCropedOpen}
                  className="mt-2 cursor-pointer text-lg font-semibold text-gray-500 hover:text-sidebar"
                >
                  {t("logo.edit")}
                </button>
              )}
            </div>

            <form
              onSubmit={handleSubmit}
              className="flex w-full max-w-3xl flex-col items-center justify-center gap-4 space-y-6 rounded-lg pt-4"
            >
              <input
                ref={inputRef}
                type="file"
                id="logo"
                name="logo"
                accept="image/*"
                onChange={(e) => {
                  setButtonView(true);
                  toggleCropedOpen();
                  handleFileChange(e, "logo");
                }}
                className="hidden"
              />
              {/* Form */}
              <div className="flex size-full flex-col gap-4">
                <h1 className="text-xl capitalize">
                  {t("generalSettings.restaurantInfo")}
                </h1>

                {/* Restaurant Name */}
                <div className="w-full space-y-1">
                  <label>{t("generalSettings.restaurantName")}</label>
                  <ResturantNameInput
                    resturnatNames={{
                      ar: formData.nameAR,
                      en: formData.nameEn,
                    }}
                    onChange={updateRestaurantName}
                  />
                  {nameError && (
                    <p className="text-sm text-red-500">
                      {t("generalSettings.restaurantNameRequired")}
                    </p>
                  )}
                </div>

                {/* Restaurant Description */}
                <div className="w-full space-y-1">
                  <label>{t("generalSettings.restaurantDescription")}</label>
                  <ResturantDescription
                    resturantDescriptions={{
                      ar: formData.descriptionAr,
                      en: formData.descriptionEn,
                    }}
                    onChange={updateRestaurantDescription}
                  />
                  {discriptionError && (
                    <p className="text-sm text-red-500">
                      {t("generalSettings.restaurantDescriptionRequired")}
                    </p>
                  )}
                </div>

                {/* Favicon Section */}
                <div className="mt-3 w-full space-y-4">
                  <h3 className="text-lg">
                    {t("generalSettings.chooseFavicon")}
                  </h3>
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex-1">
                      <label
                        htmlFor="favicon"
                        className="cursor-pointer rounded-md bg-sidebar px-4 py-2 text-base font-semibold text-skyblue"
                      >
                        {t("generalSettings.uploadFavicon")}
                      </label>
                      <input
                        type="file"
                        id="favicon"
                        name="favicon"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "favicon")}
                        className="hidden"
                      />
                    </div>
                    <div className="flex flex-col items-center gap-1">
                      <div className="h-16 w-16 relative overflow-hidden rounded bg-gray-200">
                        {fileURLs.favicon ? (
                          <>
                            <img
                              src={fileURLs.favicon}
                              alt="Favicon Preview"
                              className="h-full w-full object-cover"
                            />
                            <span onClick={() => setFileURLs({ ...fileURLs, favicon: "" })} className="absolute top-0 flex h-6 w-6 items-center justify-center rounded-full bg-red-500 text-sm cursor-pointer text-white">X</span>
                          </>
                        ) : (
                          <span className="flex h-full w-full items-center justify-center text-center text-sm text-gray-500">
                            {t("generalSettings.noFavicon")}
                          </span>
                        )}
                      </div>
                      <p className="pb-1 text-sm text-slate-400">
                        {t("generalSettings.bestFaviconSize")}
                      </p>
                      <p className="pb-1 text-sm text-slate-400">{t("generalSettings.maxFileSize")}</p>

                    </div>
                  </div>
                </div>
              </div>

              {/* contact */}
              <div className="flex size-full flex-col gap-4">
                <h1 className="text-xl capitalize">
                  {t("generalSettings.contact")}

                </h1>

                {/* Phone Number */}
                <div className="w-full space-y-1">
                  <label htmlFor="restaurantPhone">
                    {t("phoneNumber")}
                  </label>
                  <div className="relative">
                    <input
                      name="restaurantPhone"
                      id="restaurantPhone"
                      className="h-full w-full rounded-md border border-gray-300 py-2 ps-14"
                      type="text"
                      placeholder={t("phoneNumber") as string}
                      value={formData.restaurantPhone}
                      onChange={updateContactInput}
                      dir="ltr"
                    />
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400">
                      966+
                    </span>
                  </div>
                  {errors.restaurantPhone && (
                    <p className="text-sm text-red-500">
                      {errors.restaurantPhone}
                    </p>
                  )}
                </div>

                {/* WhatsApp Number */}
                <div className="w-full space-y-1">
                  <label htmlFor="whatsapp">
                    {t("whatsappNumber")}
                  </label>
                  <div className="relative">
                    <input
                      name="whatsapp"
                      id="whatsapp"
                      className="h-full w-full rounded-md border border-gray-300 py-2 ps-14"
                      type="text"
                      placeholder={
                        t("whatsappNumber") as string
                      }
                      value={formData.whatsapp}
                      onChange={updateContactInput}
                      dir="ltr"
                    />
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400">
                      966+
                    </span>
                  </div>
                  {errors.whatsapp && (
                    <p className="text-sm text-red-500">{errors.whatsapp}</p>
                  )}
                </div>



                {/* Instagram */}
                <div className="w-full space-y-1">
                  <label htmlFor="instagram">
                    {t("instagram")}
                  </label>
                  <input
                    name="instagram"
                    id="instagram"
                    className="h-full w-full rounded-md border border-gray-300 p-2"
                    type="text"
                    placeholder={t("instagramUrl") as string}
                    value={formData.instagram}
                    onChange={updateContactInput}
                    dir="ltr"
                  />
                  {errors.instagram && (
                    <p className="text-sm text-red-500">{errors.instagram}</p>
                  )}
                </div>



              </div>
              <div className="w-full space-y-1">
                <label htmlFor="tiktok">{t("tiktok")}</label>
                <input
                  name="tiktok"
                  id="tiktok"
                  className="h-full w-full rounded-md border border-gray-300 p-2"
                  type="text"
                  placeholder={t("tiktokUrl") as string}
                  value={formData.tiktok}
                  onChange={updateContactInput}
                  dir="ltr"
                />
                {errors.tiktok && (
                  <p className="text-sm text-red-500">{errors.tiktok}</p>
                )}
              </div>

              <div className="w-full space-y-1">
                <label htmlFor="snapchat">{t("snapchat")}</label>
                <input
                  name="snapchat"
                  id="snapchat"
                  className="h-full w-full rounded-md border border-gray-300 p-2"
                  type="text"
                  placeholder={t("snapchatUrl") as string}
                  value={formData.snapchat}
                  onChange={updateContactInput}
                  dir="ltr"
                />
                {errors.snapchat && (
                  <p className="text-sm text-red-500">{errors.snapchat}</p>
                )}
              </div>


              <div className="w-full space-y-1">
                <label htmlFor="facebook">{t("facebook")}</label>
                <input
                  name="facebook"
                  id="facebook"
                  className="h-full w-full rounded-md border border-gray-300 p-2"
                  type="text"
                  placeholder={t("facebookUr") as string}
                  value={formData.facebook}
                  onChange={updateContactInput}
                  dir="ltr"
                />
                {errors.facebook && (
                  <p className="text-sm text-red-500">{errors.facebook}</p>
                )}
              </div>
              <div className="w-full space-y-1">
                <label htmlFor="linkedin">{t("linkedin")}</label>
                <input
                  name="linkedin"
                  id="linkedin"
                  className="h-full w-full rounded-md border border-gray-300 p-2"
                  type="text"
                  placeholder={t("linkedinUrl") as string}
                  value={formData.linkedin}
                  onChange={updateContactInput}
                  dir="ltr"
                />
                {errors.linkedin && (
                  <p className="text-sm text-red-500">{errors.linkedin}</p>
                )}
              </div>
              <div className="w-full space-y-1">
                <label htmlFor="x">{t("xPlatform")}</label>
                <input
                  name="x"
                  id="x-Platform"
                  className="h-full w-full rounded-md border border-gray-300 p-2"
                  type="text"
                  placeholder={t("xPlatformUrl") as string}
                  value={formData.x}
                  onChange={updateContactInput}
                  dir="ltr"
                />
                {errors.x && (
                  <p className="text-sm text-red-500">{errors.x}</p>
                )}
              </div>
              {/* Submit Button */}
              <button
                type="submit"
                className="w-fit self-center rounded-md bg-sidebar px-10 py-2 font-semibold text-skyblue transition"
              >
                {t("save")}
              </button>
            </form>
          </div>
        </>
      )}
    </>
  );
}

export default GeneralSettings;
